import { Component, Inject, OnInit } from '@angular/core';

import { AmplitudeService } from '@sondermind/amplitude';
import { ILaunchDarklyUser, LAUNCH_DARKLY_SERVICE, LaunchDarklyService } from '@sondermind/launch-darkly';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})

export class AppComponent implements OnInit {
  constructor(
    @Inject(LAUNCH_DARKLY_SERVICE)
    private launchDarklyService: LaunchDarklyService,
    private amplitudeService: AmplitudeService
  ) {
    this.initLaunchDarklyClient();
  }

  ngOnInit(): void {
    this.amplitudeService.setupSessionReplay();
  }

  private initLaunchDarklyClient() {
    this.launchDarklyService.initClient(this.buildNewLaunchDarklyClient());
  }

  private buildNewLaunchDarklyClient(): ILaunchDarklyUser {
    return {
      kind: 'anonUserId',
      anonymous: true
    };
  }
}
